<template>
    <div>
        <v-toolbar dense flat color="primary" app :clipped-left="true" dark tabs>

            <v-btn icon @click="goBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Caixas & Rotas</v-toolbar-title>

        </v-toolbar>
        <main>

            <v-alert outline color="error" icon="warning" :value="error">
                {{error}}
            </v-alert>

            <div id="map" v-show="!watchID" style="height: calc(93vh)"></div>

            <v-container v-if="watchID">
                <v-alert outline color="error" icon="error" :value="true" >
                    Proximidade: {{accuracy}}m <br/> lat & lng {{out}}
                </v-alert>
            </v-container>

        </main>
    </div>
</template>

<script>
    /* eslint-disable indent */
    import axios from "axios"
    import * as L from "leaflet";

    /* global google */
    export default {
        name: "VerCaixasGoogleMaps",
        data () {
            return {
                limit: 3000,
                out: null,
                error: null,
                accuracy: null,
                myLatLng: [],
                center: [10.0, 10.0],
                items: [],
                buscando: false,
                watchID: null,
                map: null,
                bounds: new google.maps.LatLngBounds(),
                ponto: null
            }
        },
        mounted () {
            if (!navigator.geolocation) {
                alert("Geolocation not is supported!")
            } else {
                this.openLatLong()
            }
        },
        beforeDestroy () {
            if (this.watchID) {
                navigator.geolocation.clearWatch(this.watchID)
            }
        },
        methods: {
            createMap () {
                setTimeout(() => {
                    this.map = L.map('map').setView(this.center, 17);

                    let layerGoogle = L.tileLayer('http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga', {
                        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    });

                    let layerOSM = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: '&copy; OpenStreetMap contributors'
                    }).addTo(this.map);

                    let baseMaps = {
                        "Google": layerGoogle,
                        "Open Street Maps": layerOSM
                    };

                    L.control.layers(baseMaps).addTo(this.map);

                    this.getCaixas();

                    L.marker(this.center).addTo(this.map);
                });
            },
            openLatLong: function () {
                this.dialog = false;
                this.watchID = navigator
                    .geolocation
                    .watchPosition(
                        this.processGeolocation,
                        this.geolocationError,
                        {
                            enableHighAccuracy: true,
                            timeout: 3000,
                            maximumAge: 0
                        }
                    )
            },
            processGeolocation: function (position) {
                console.log(position);
                this.out = position.coords.latitude + "," + position.coords.longitude;
                this.center = [
                    position.coords.latitude,
                    position.coords.longitude
                ];
                this.accuracy = position.coords.accuracy;
                if (this.accuracy <= this.limit) {
                    navigator.geolocation.clearWatch(this.watchID);
                    this.watchID = null;
                    this.createMap()
                }
            },
            geolocationError: function (error) {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        this.error = "User denied the request for Geolocation.";
                        break;
                    case error.POSITION_UNAVAILABLE:
                        this.error = "Location information is unavailable.";
                        break;
                    case error.TIMEOUT:
                        this.error = "The request to get user location timed out.";
                        break;
                    case error.UNKNOWN_ERROR:
                        this.error = "An unknown error occurred.";
                        break
                }
            },
            getCaixas () {
                axios
                    .get("https://gestor.centersattelecom.com.br/api/caixas/800/" + this.center[0] + "/" + this.center[1])
                    .then((dados) => this.loadCaixas(dados.data));

                axios
                    .get("https://gestor.centersattelecom.com.br/api/linhas")
                    .then((dados) => this.loadLinha(dados.data))
            },
            loadCaixas (dados) {
                dados.ctos.forEach((cto) => this.processCaixas(cto, "CTO"));
                dados.switchs.forEach((swit) => this.processCaixas(swit, "SWITCH"));
                dados.pacpon.forEach((pacpon) => this.processCaixas(pacpon, "PACPON"));
                dados.emendas.forEach((pacpon) => this.processCaixas(pacpon, "EMENDA"));
                dados.reservas.forEach((pacpon) => this.processCaixas(pacpon, "RESERVA"));
            },
            processCaixas (d, tipo) {
                let contentString = "<div id=\"content\">" +
                    "<div id=\"siteNotice\">" +
                    "</div>" +
                    "<p><b>" + d.nome + "</b></p>" +
                    "</div>";

                let icon = null;

                if (tipo === "CTO") {
                    icon = "https://gestor.centersattelecom.com.br/maps/cto.png";
                } else if (tipo === "SWITCH") {
                    icon = "https://gestor.centersattelecom.com.br/maps/switch.png";
                } else if (tipo === "PACPON") {
                    icon = "https://gestor.centersattelecom.com.br/maps/pacpon.png";
                } else if (tipo === "EMENDA") {
                    icon = "https://gestor.centersattelecom.com.br/maps/emendas.png";
                } else if (tipo === "RESERVA") {
                    icon = "https://gestor.centersattelecom.com.br/maps/reserva.png";
                }

                var LeafIcon = L.Icon.extend({
                    options: {
                    }
                });

                let greenIcon = new LeafIcon({ iconUrl: icon });

                switch (tipo) {
                    case "CTO":
                        contentString = "<div><b>" + d.nome + "</b></div><br><br><a href='#/caixa/cto/" + d._id + "'>VER CAIXA CTO</a></div>";
                        break;
                    case "PACPON":
                        contentString = "<div><b>" + d.nome + "</b><br><br><a href='#/caixa/pacpon/" + d._id + "'>VER CAIXA PACPON</a></div>";
                        break;
                }

                L.marker([d.place[1], d.place[0]], { icon: greenIcon })
                    .addTo(this.map)
                    .bindPopup(contentString);
            },
            loadLinha (dados) {
                dados.forEach((d) => {
                    let polyline = L.polyline(d.places, { color: d.cor }).addTo(this.map);
                    polyline._id = d._id;
                    polyline.obs = d.obs;
                });
            }
        }
    }
</script>

<style scoped>

</style>
